import DocActivity from './DocActivity';

export default DocActivity;
